// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"41":"relay-portal","258":"whiteboard","690":"zxcvbn"}[chunkId] + "." + {"41":"00b99de38f57","258":"461db3a756f8","690":"f35b001e2f1d"}[chunkId] + ".chunk.min.js";
};